import React from "react";

const Details = ({ rowData }) => {
  if (!rowData) return <p>No data available</p>;

  const fields = [
    { label: "ID", key: "id" },
    { label: "Kiosk ID", key: "kioskId" },
    { label: "Kiosk Name", key: "kioskName" },
    { label: "Total Amount", key: "totalAmount" },
    { label: "Alert Threshold Indicator", key: "alertThresholdIndicator" },
    { label: "Warning Threshold Indicator", key: "warningThresholdIndicator" },
    { label: "Cash Denominations", key: "cashDenominations" },
    { label: "Created Date", key: "createdDate" },
    { label: "Last Updated", key: "lastUpdated" },
    { label: "Status", key: "status" },
  ];

  return (
    <div className="main-form">
      <div className="p-fluid formgrid grid">
        {fields.map(({ label, key }) => (
          <div key={key} className="field col-12 md:col-4 mb-3">
            <label>{label}</label>
            <p>{rowData[key] || "N/A"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
